import { itil } from '@tencent/ppd-base-libs';
import { report } from '@tencent/ppd-report-sdk-web';


const businessName = '';

const reportedMap: Record<string, boolean> = {};


export class CustomException {
  business: string;
  name: string;
  message: string;
  stack: string;
  data: any;
  hasReportToSentry?: boolean;

  // message为代码中的关键字，后续可以搜索到代码对应的逻辑
  constructor(err: any, name: string, message: string, option: any = { noReportZhiyan: false, business: businessName, itilId: '', reportOnce: false, noReportAcc: false, alarmCfg: {} }) {
    // super();
    const opts = option || {};
    const { noReportZhiyan, business, reportOnce, itilId } = opts;
    this.business = business;
    // name作为自定义异常的key,用户搜索
    this.name = name || 'BaseException';
    // 自定义异常，更多的附加信息
    this.message = message || 'default Message';
    // 当有系统报出的错误，是有stack的，就用系统报错的stack。如果没有，那可能是来自某个reject,那这个就用当前的堆栈
    this.stack = err?.stack || '';

    // err有可能是string,也可能是error对象，也可能是http请求的reject。
    // 当如果是http请求的reject，可能外层处理，需要用到data，比如密码校验失败，展示弹窗时候，需要这里很多数据
    // 这里是为了能够把reject的数据，携带出去，携带到最上层的自定义错误
    const data = err?.data || err;
    if (!(data instanceof Error) && typeof data === 'object') {
      this.data = data;
    } else {
      // 有些地方直接reject一个string,又不是JsError，这种情况也需要记录下来
      if (typeof data === 'string') {
        this.data = { defaultMsg: data };
      } else {
        this.data = null;
      }
    }
    // 当是系统爆出的badjs异常，就上报sentry,
    if (
      err?.stack
      && /^(Error|EvalError|RangeError|ReferenceError|SyntaxError|TypeError|URIError):(.*)?\n/.test(err.stack)
      && !err.hasReportToSentry
    ) {
      this.hasReportToSentry = true;
    }
    if (itilId) {
      itil(itilId);
    }
    // 如果错误只上报一次，且已经上报过，就不上报elk了
    if (reportOnce && reportedMap[this.name]) {
      return;
    }
    // 上报zhiyan
    if (!noReportZhiyan) {
      this.reportZhiyan(business);
    }
  }

  /**
   * 获取数据
   * @return {[type]} [description]
   */
  getData() {
    return this.data;
  }

  /**
   * 控制台输出错误
   * @return {[type]} [description]
   */
  logError() {
    // 这里做一次log,log除了badjs之外的异常。badjs的异常，是sentry那边shouldSendCallback上报了
    console.error(
      '%c%s',
      'color: white; background: red; font-size: 12px; padding: 2px;',
      `[ ${this.name} ] ${this.message}\n`,
      'stack:\n',
      this.stack,
      '\ndata:\n',
      this.data,
    );
  }

  /**
   * 上报zhiyan
   * @return {[type]} [description]
   */
  reportZhiyan(options: any) {
    reportedMap[this.name] = true;
    // 上报前，log一下
    this.logError();
    const defaultOptions = {
      key: this.name,
      msg: this.message,
      ext1: 'CustomException', // 后续通过这个字段来做视图
      ext2: this.stack ? this.stack.substr(0, this.stack.indexOf('\n')) : '', // 记录stack,只记录一行
      errorMsg: JSON.stringify(this.data), // 记录http错误，接口的返回，或者jsapi调用错误的返回
    };
    const param = Object.assign({}, defaultOptions, options);

    report.reportException(param, this.name, this.message);
  }
}
